import { Link } from 'react-router-dom';
import { useEffect } from 'react';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40 md:hidden"
        onClick={onClose}
      />
      
      {/* Menu Panel */}
      <div className="fixed top-0 right-0 bottom-0 w-[280px] bg-white z-50 md:hidden shadow-2xl">
        <div className="flex flex-col h-full">
          {/* Close Button */}
          <div className="flex justify-end p-6">
            <button 
              onClick={onClose}
              className="w-10 h-10 flex items-center justify-center text-black hover:text-primary transition-colors"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex-1 px-6">
            <div className="space-y-1">
              <Link 
                to="/" 
                onClick={onClose}
                className="block py-4 text-black hover:text-primary transition-colors text-base font-medium uppercase tracking-wider border-b border-gray-100"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                onClick={onClose}
                className="block py-4 text-black hover:text-primary transition-colors text-base font-medium uppercase tracking-wider border-b border-gray-100"
              >
                About
              </Link>
              <Link 
                to="/services" 
                onClick={onClose}
                className="block py-4 text-black hover:text-primary transition-colors text-base font-medium uppercase tracking-wider border-b border-gray-100"
              >
                Services
              </Link>
              <Link 
                to="/work" 
                onClick={onClose}
                className="block py-4 text-black hover:text-primary transition-colors text-base font-medium uppercase tracking-wider border-b border-gray-100"
              >
                Work
              </Link>
              <Link 
                to="/resources" 
                onClick={onClose}
                className="block py-4 text-black hover:text-[#ff4858] transition-colors text-base font-medium uppercase tracking-wider border-b border-gray-100"
              >
                Insights
              </Link>
              <div className="pt-4">
                <Link 
                  to="/contact" 
                  onClick={onClose}
                  className="block w-full bg-primary text-white px-6 py-4 rounded-full hover:bg-primary/90 transition-all duration-200 text-sm font-bold uppercase tracking-wider text-center whitespace-nowrap"
                >
                  Contact
                </Link>
              </div>
            </div>
          </nav>

          {/* Spacer */}
          <div className="p-6" />
        </div>
      </div>
    </>
  );
}